import { render, staticRenderFns } from "./MeldenBase.vue?vue&type=template&id=7274e486&scoped=true&"
import script from "./MeldenBase.vue?vue&type=script&lang=js&"
export * from "./MeldenBase.vue?vue&type=script&lang=js&"
import style0 from "./MeldenBase.vue?vue&type=style&index=0&id=7274e486&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7274e486",
  null
  
)

export default component.exports